import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { WebsocketEffects } from './effects/websocket.effects';

@NgModule({
    imports: [CommonModule, EffectsModule.forFeature([WebsocketEffects])],
})
export class WebsocketStoreModule {}
